<template>
	<div :class="useOffset ? 'breadcrumb-with-offset' : 'breadcrumb-without-offset'" class="breadcrumb-container">
		<button class="breadcrumb-link d-flex align-items-center" v-on:click="onClick">
			<img class="header-logo mr-3" src="~@img/misc/back.png"/>
			<h5 class="mb-0">{{ $t('misc.back') }}</h5>
		</button>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
  import {mapGetters} from "vuex";
	import PagePhase from "@/enum/PagePhase";

	export default {
		name: 'breadcrumb',
		props: {
			to: {
				required: true
			},
			useOffset: {
				type: Boolean,
				required: false,
				default: true
			}
		},
    computed: {
      ...mapGetters({
        currentPageIndex: 'getCurrentPageIndex',
        currentPagePhase: 'getCurrentPagePhase',
      })
    },
		methods: {
      onClickGoBack() {
      },
			onClick() {
        if (this.currentPageIndex > 0) {
          if (this.currentPagePhase === PagePhase.Normal) {
            // None result page, go back to previous page
            this.$gameClient.send({
              _currentPageIndex: this.currentPageIndex - 1
            });
          } else if (this.currentPagePhase === PagePhase.Result) {
            // Result page, go back to non result page
            this.$gameClient.send({
              _currentPagePhase: PagePhase.Normal
            });
          }

          return;
        }

				this.$emit('onClick');

				if (typeof(this.to) === 'function') {
					this.to.apply();
				} else {
					this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, false);
					this.$router.push(this.to)
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/variables.less";

	.breadcrumb-container {
		&.breadcrumb-with-offset {
			position: relative;
			top: @breadcrumb-offset;
			margin-bottom: @breadcrumb-offset;
		}
	}

	.breadcrumb-link {
		cursor: pointer;
		font-size: @app-font-size-breadcrumb;
		border: none;
		background-color: transparent;

		&:focus {
			outline: none;
		}
	}
</style>